import {workplaceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {HeaderMenuBlock} from "../Block/HeaderMenuBlock/HeaderMenuBlock";
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

var ConveyerBagTape = {
    set: function (flightId, timeType, baggageTapeId) {
        var data = {
            flightId,
            timeType,
            baggageTapeId: Number(baggageTapeId)
        };

        m.request({
            method: 'POST',
            url: '/api/baggage-tape/time',
            data: data
        }).then(function (response) {
            loader.hide();

            if(timeType == 1) {
                m.route('/conveyer/flights');
            } else {
                m.route('/conveyer/flights/' + flightId + '/time');
            }

        }, function (response) {
            server.setOffline();
            loader.hide();
        });
    }
};

export var ConveyerFlightsTimePage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.conveyer) {
            m.route('/');
            return;
        }

        interval.clearAll();

        loader.show();

        this.data = m.request({
            method: 'GET',
            url: '/api/conveyer/flights/' + m.route.param('flightId')
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            server.initPing();

            if(response.flight.bagWorkerFactBegin && response.flight.bagWorkerFactEnd) {
                m.route('/conveyer/flights');
            }

            return response;
        }, function (response) {
            m.route('/conveyer/flights');
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
        this.topMenu = [
            { title: 'Рейсы', url: '/conveyer/flights', icon: 'fa-plane' },
            isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
            { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' },
        ]
    },
    view: function (ctrl) {
        return [
            // m(".bg-primary", [
            //     m(".container.text-right[style='padding:10px;']", [
            //         m("a[style='color:#fff;padding-left:7px']", {
            //             href: '/conveyer/flights',
            //             config: m.route
            //         }, [
            //             m("span.fa.fa-plane"),
            //             m.trust('&nbsp;Рейсы')
            //         ]),
            //         isEnabledMsg() ?
            //             m("a[style='color:#fff;padding-left:7px']", {
            //                 href: '/message',
            //                 config: m.route
            //             }, [
            //                 m("span.fa", {
            //                     class: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o'
            //                 }),
            //                 m.trust('&nbsp;Сообщения')
            //             ]) : [],
            //         m("a[style='color:#fff;padding-left:7px']", {
            //             href: '/logout',
            //             config: m.route
            //         }, [
            //             m("span.fa.fa-sign-out"),
            //             m.trust('&nbsp;Выйти')
            //         ])
            //     ])
            // ]),
            // m(".bg-info", [
            //     m(".container[style='padding:5px;']", [
            //         m(".pull-right.dateTimerControl", [
            //             m.component(TimerControl, {time: ctrl.data().time}),
            //             m.component(onlineIndicator)
            //         ]),
            //         m(".pull-left", [
            //             m("span", user.get('name'))
            //         ])
            //     ])
            // ]),
            m.component(HeaderMenuBlock, {
                time: {},
                menu: ctrl.topMenu
            }),

            m(".bg-primary[style='padding:7px;margin-top:5px']", [
                m(".container.text-center", [
                    m("div[style='display:inline-block;margin-right:15px']",
                        'Выбранная лента выдачи багажа: ' + localStorage.getItem('baggageTapeName') + "; " +
                        "Рейс: " + ctrl.data().flight.boardNumber + "; " +
                        "Время прибытия рейса: " + ctrl.data().flight.date + ' ' + ctrl.data().flight.time
                    )
                ])
            ]),
            ctrl.data().flight.bagWorkerFactBegin ?
                m("h3.text-center.v-center[style='margin-top: 60px;margin-bottom: -50px; font-size: 70px;']", [
                    m('span', ctrl.data().flight.bagWorkerFactBegin.substring(11,16)),
                ]) : m("button.btn.btn-info.btn-block.btn-lg.btn-flight-time", {
                    onclick: function () {
                        ConveyerBagTape.set(ctrl.data().flight.id, 0, localStorage.getItem('baggageTapeId'));
                    }
                }, [
                    m("span", "Начать выкладку"),
                ]),

            m("button.btn.btn-danger.btn-block.btn-lg.btn-flight-time[style='margin-top: 100px;']", {
                disabled: ctrl.data().flight.bagWorkerFactBegin ? '' : 'disabled',
                onclick: function () {
                    ConveyerBagTape.set(ctrl.data().flight.id, 1, localStorage.getItem('baggageTapeId'));
                }
            }, [
                m("span", "Завершить выкладку")
            ]),
        ];
    }
};
